// yksi totuus: aina dashboardiin
export function getPathForRole() {
  return '/dashboard';
}
